import React from 'react';
import { useMediaQuery } from '@mui/material';
import ResponsiveAppBar from './ResponsiveAppBar';
import PageAppBar from '../PageAppBar';

function ResponsiveComponent() {
  // Use MUI's useMediaQuery hook to check screen size
  const isSmallerScreen = useMediaQuery('(max-width:1100px)');

  return isSmallerScreen ? <ResponsiveAppBar /> : <PageAppBar /> ;
};
export default ResponsiveComponent;
